/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable jsx-a11y/label-has-associated-control */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { useUser, useSetUser } from '../../contexts/AuthContext';
import EditProfileForm from '../forms/EditProfile';
import MainLayout from '../layouts/Main';
import ConfirmEmail from '../notifications/ConfirmEmail';
import UserPlaceholder from '../partials/UserPlaceholder';
import UserSidebar from '../partials/UserSidebar';

import styles from '../../../styles/pages/account.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ProfilePage = ({ className }) => {
    const user = useUser();
    const setUser = useSetUser();
    const onUserSaved = useCallback(
        (value) => {
            setUser(value);
        },
        [setUser],
    );
    const { emailVerified = false } = user || {};
    return (
        <MainLayout>
            <div
                className={classNames([
                    styles.container,
                    {
                        [className]: className !== null,
                    },
                ])}
            >
                <div className={styles.inner}>
                    {user === null ? (
                        <UserPlaceholder className={styles.placeholder} />
                    ) : (
                        <>
                            <UserSidebar user={user} showDelete className={styles.sidebar} />
                            <div className={styles.main}>
                                {!emailVerified ? (
                                    <ConfirmEmail className={styles.notification} />
                                ) : null}
                                <div className={styles.content}>
                                    <h2 className={styles.title}>
                                        <FormattedMessage
                                            defaultMessage="Your profile"
                                            description="Section title"
                                        />
                                    </h2>
                                    <EditProfileForm onComplete={onUserSaved} />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </MainLayout>
    );
};

ProfilePage.propTypes = propTypes;
ProfilePage.defaultProps = defaultProps;

export default ProfilePage;
